import { TCustomerInfo, TPayoutInfo } from "../bloc/payoutsSlice";

export interface PayoutDataResponse {
  utr: string;
  createdOn: string;
  type: string;
  receiver: string;
  txnAmt: number;
  payoutId: string;
  txnStatus: string;
  benCode: string;
  prodId: string;
}

export interface CustomerProfile {
  benCode: string;
  businessName: string;
}

export const mapPayoutResponseToModel = (data: PayoutDataResponse[]) => {
  let payouts: TPayoutInfo[] = [];
  data.forEach((d) => {
    payouts.push({
      utr: d.utr,
      createdOn: d.createdOn,
      type: d.type,
      receiver: d.receiver,
      amount: d.txnAmt,
      payoutId: d.payoutId,
      status: d.txnStatus,
      benCode: d.benCode,
      prodId: d.prodId,
    });
  });

  return payouts;
};

export const mapCustomersResponseToModel = (data: CustomerProfile[]) => {
  let customers: TCustomerInfo[] = [];
  data.forEach((d) => {
    customers.push({
      customerName: d.businessName,
      benCode: d.benCode,
    });
  });

  return customers;
};
